export default "__VITE_ASSET__rRxZ9Av3__"